import React, { useState, useEffect, useRef, useCallback, useLayoutEffect } from 'react';
import IconsPath from '../assets/icons/index'
import NoDataFound from './NoDataFound'
import { dispatchHandler } from '../helper/apiHelperFunctions.js'
import { useDispatch, useSelector } from 'react-redux';
import ListComponentSkeltonLoader from '../components/skeletons/ListComponentSkeltonLoader.jsx';
import GenericSpinnerLoader from '../loaders/GenericSpinnerLoader.jsx'
import $, { data } from 'jquery'
import GenericCustomButton from './GenericCustomButton.jsx'
import LanguageTranslator from '../locals/LanguageTranslator.js';
import Icons from '../assets/icons/index';
import { ChevronDown, FileImage, FileText, FileVideo, SquareArrowOutUpRight } from 'lucide-react';
import ColorComponent from './ColorComponent.jsx';
import { Dropdown, Space } from 'antd';
import GenericInput from './input/GenericInputComponent.jsx';
import { scrollIntoViewIfNeeded } from '../helper/genericFunction.js';

const ListComponent = (props) => {
	const OS = navigator.userAgentData && navigator.userAgentData.platform;
	// label: It will contain the props for the label section.
	// search: It will have the props for left, right component of search as well as search options
	// totalRecords: It can be the key to access total records or it can be the function which is going to return the total records.
	// multiselectOptions: Key to identify to show the multiselect type of list options or not.
	// headerKeys are the headers of the table -> min headers will be 1 and each header keys can have 3 itemKeys (i.e three level of item) -> We will not show header is its length is only one 
	// itemKeys are the keys for rendering the list data.
	// hoverKey : To differentiate between the listComponentHover class of multiple list component
	// useKeyboardShortcuts : To disable the keyboard shortcuts
	// updateListdataWithInitialSelectedData : To update the intial list data with the selected data as some date may not be present inside the list data.
	// isListItemDisabled : to check if the item inside the list component is disabled or not
	const {
		label,
		search,
		totalRecords,
		api,
		headerKeys,
		itemKeys,
		multiselect,
		rowLeftComponent,
		rowRightComponent,
		modalMainClass,
		viewDataType,
		hoverKey = "",
		useKeyboardShortcuts = true,
		updateListdataWithInitialSelectedData = false,
		isListItemDisabled,
		isTrainingGuideModal = false,
		showSelectedDataCheck = false,
		footerButtonSize = 'small',
		showColor = false
	} = props;

	let hoverClassName = `listComponentHover${hoverKey}`

	// List Component States
	const [listData, setListData] = useState(props?.api ? [] : props?.getListData?.());
	const [selectedData, setSelectedData] = useState(multiselect ? multiselect.selectedData || {} : {});
	const [currentSearch, setCurrentSearch] = useState(props.initialSearch || "");
	const [focusOn, setFocusOn] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [maxPage, setMaxPage] = useState(0);
	const [searchFilter, setSearchFilter] = useState(props.search?.searchOptions ? Object.keys(props.search?.searchOptions || {})?.[0] : "");
	const [mouseMovement, setMouseMovement] = useState(false);
	const inputSearchRef = useRef(null);
	const [apiAllData, setApiAlldata] = useState({})
	const debounceTimerRef = useRef(null);

	useEffect(() => {
		if(props?.refreshSelectedData) {
			setSelectedData(multiselect?.selectedData || {});
		}
	}, [props?.refreshSelectedData])

	// State to store the index of the currently focused element
	const [focusedIndex, setFocusedIndex] = useState(null);

	const dispatch = useDispatch();
	let observerTarget = useRef();

	let apiReduxData = useSelector(state => state?.[api?.["reduxState"]]);

	// Function : To get the ref for the last element of the list.
	const lastListElementRef = (node) => {
		if (apiReduxData?.[`${props?.api?.apiName}Data`]?.isLoading) return;

		if (listData && listData?.length == 0) return;
		if (observerTarget?.current) observerTarget.current.disconnect();
		observerTarget.current = new IntersectionObserver(entries => {
			if (entries?.[0].isIntersecting) {
				// So that the state current page and max page state gets updated
				moveNextPage();
			}
		})
		if (node) observerTarget.current.observe(node);
	}

	useEffect(() => {
		// Set up the keyboard shortcuts 
		if (inputSearchRef?.current) {
			inputSearchRef?.current.focus();
		}
	}, [])

	// TO apply tge jeyvoard shortcuts to the list.
	useLayoutEffect(() => {
		document.addEventListener("keydown", keyboardShortcuts);
		return (() => {
			document.removeEventListener("keydown", keyboardShortcuts)
		});
	}, [listData, selectedData, focusedIndex])

	// Function to handle the keyboard shortcuts
	const keyboardShortcuts = (e) => {
		const dataLength = listData?.length || 0;
		if (dataLength) {
			let hoveredElem = $(`.${hoverClassName}.hover`);
			if (e.key === "ArrowDown" && useKeyboardShortcuts) {
				e.preventDefault();
				if (focusedIndex == null) {
					setFocusedIndex(0);
				}
				else {
					if (focusedIndex < dataLength - 1) {
						setFocusedIndex(focusedIndex + 1);
					} else {
						setFocusedIndex(0);
					}
				}
			}
			else if (e.key === "ArrowUp" && useKeyboardShortcuts) {
				e.preventDefault();
				if (focusedIndex == null) {
					setFocusedIndex(dataLength - 1);
				}
				else {
					if (focusedIndex > 0) {
						setFocusedIndex(focusedIndex - 1);
					} else {
						setFocusedIndex(dataLength - 1);;
					}
				}
			}
			else if (e.key === "Enter" && e.shiftKey && useKeyboardShortcuts) {
				hoveredElem.trigger("click");
			} else if (e.keyCode === 70 && (OS === "macOS" ? e.metaKey : e.ctrlKey) && useKeyboardShortcuts) {
				e.preventDefault();
				if (inputSearchRef?.current) {
					inputSearchRef?.current.focus();
				}
			}
			else if (e.key === "esc") {
				props?.closeModal();
			}
		}
	}

	useEffect(() => {
		// To move the hovered element to the list
		!mouseMovement && scrollIntoViewIfNeeded($(`.${hoverClassName}.hover`)[0]);
		mouseMovement && setMouseMovement(false);
	}, [selectedData, listData, focusedIndex])


	const handleMouseMove = (e, index) => {
		useKeyboardShortcuts && setMouseMovement(true);
		useKeyboardShortcuts && setFocusedIndex(index);
	}

	{
		// Section to handle the useEffect for the api of the component
		useEffect(() => {
			if (apiReduxData?.[`${props?.api?.apiName}Data`]?.isSuccess) {
				let allStates = getComponentStates();
				let allFunctions = getComponentFunctions();
				let response = apiReduxData?.[`${props?.api?.apiName}Data`]?.data;
				setMaxPage(prev => props.api?.getMaxPage ? props?.api?.getMaxPage(allStates, allFunctions, response) : response?.["maxPage"]);
				updateListData(response, currentPage == 1 ? "reset" : "update");
				setApiAlldata(response);
			}
		}, [props?.api ? apiReduxData?.[`${props?.api?.apiName}Data`]?.isSuccess : {}])

		useEffect(() => {
			if (apiReduxData?.[`${props?.api?.apiName}Data`]?.isError) {
				window.scrollTo({
					top: 0,
					behavior: 'smooth',
				});
				setMaxPage(0);
				setListData([]);
				setApiAlldata({})
			}
			currentPage > 1 && setCurrentPage(prev => prev - 1);
		}, [props?.api ? apiReduxData?.[`${props?.api?.apiName}Data`]?.isError : {}])

	}
	{
		// Section to handle the refresh triggered from the parent component
		useEffect(() => {
			if (props.refreshData) {
				if (api) {
					if (currentPage == 1) {
						getTableData();
					} else {
						setCurrentPage(1);
					}
				} else {
					updateListData([], "reset")
				}
			}
		}, [props.refreshData])
	}

	{
		// Section to handle all the useEffects of the List Component

		useEffect(() => {
			// If the list is an api type of list then we call the api here otherwise update the list data
			if (api) {
				getTableData();
			} else {
				updateListData([], "reset");
			}

		}, [currentPage])

	}

	const getTableData = (params = {}) => {
		const {
			search = currentSearch || "", // Getting the current search value
		} = params;

		let payload = props?.api?.apiPayload({
			currentSearch: `${search}`,
			currentPage: currentPage,
			searchFilter: searchFilter
		})
		dispatchHandler(dispatch, `${props?.api?.apiName}Request`, payload, props?.api?.apiExtraHeaders || {});
	}

	const moveNextPage = () => {
		if (Number(currentPage || "") < Number(maxPage || "") && listData?.length > 0) {
			let pageNo = currentPage;
			pageNo += 1;
			setCurrentPage(pageNo);
		}
	}


	// Function => To Provide all the states of the component
	const getComponentStates = () => {
		return {
			listData, currentSearch, currentPage, maxPage, apiAllData
		}
	}

	// Function => To Provide all the functions of the list component.
	const getComponentFunctions = () => {
		return {
			isAllListDataSelected,
			handleChange
		}
	}

	// Function => To set the list data from the function provided by the parent component
	const updateListData = (data, key) => {
		let updatedData = props?.getListData?.(data) || [];

		switch (key) {
			case "reset": {
				setListData(updateListdataWithInitialSelectedData ? [...Object.values(selectedData || {}), ...updatedData] : updatedData)
				break;
			}
			case "update": {
				setListData([...listData, ...updatedData]);
				break;
			}
		}
	}


	// Function => To check if all the list data is selected or not
	const isAllListDataSelected = () => {
		// It is going to return a boolean value.
		let id = props?.multiselect?.selectId || "id";
		return listData?.every(item => selectedData?.[item?.[id]]);
	}

	const renderHeaderComponent = () => {
		return (
			// /* The label and header component 
			label && (typeof (label) == "function" ? label() : <div className={`modal-header-section ${isTrainingGuideModal ? '!items-start' : ''}`}>

				<div className='mhs-left'>
					{/* Render the Left Side component of the label data */}
					{label.leftComponent && <div>{
						typeof (label.leftComponent) == "function" ? label.leftComponent() : label.leftComponent
					}</div>}

					{/* Render the actual labelData  */}
					{label.content && <LanguageTranslator tag="h4">{typeof (label.content) == "function" ? label?.content() : label?.content}</LanguageTranslator>}
					{label.contentSecondry && <LanguageTranslator tag="h4">{typeof (label.contentSecondry) == "function" ? label?.contentSecondry?.() : label?.contentSecondry}</LanguageTranslator>}
				</div>

				<div className='mhs-right'>
					{/* Render the right component in the header section */}
					{label.rightComponent && <>
						{typeof (label.rightComponent) == "function" ? label.rightComponent() : label.rightComponent}
					</>}
					{/* Render the close options at the end of the label data */}
					{props.closeModal && <button className='m-lft-10' onClick={() => { props.closeModal() }}><IconsPath.ModalCloseIcon /></button>}
				</div>
			</div>)
		)
	}

	const renderSearchComponent = () => {

		const items = [
			{ label: 'Exact', key: '1' },
			{ label: 'Separate With Spaces', key: '2' },
			{ label: 'Separate With Commas', key: '3' },
		];

		return (
			// The Search Component to render the search with left component with right component.
			search && (
				typeof (search) == "function"
					? search() :
					<React.Fragment>
						<div className={`modal-search-area ${!label && 'p-tb-10'}`}>
							{/* Render the left component of the input field */}
							<div className={`msa-left ${isTrainingGuideModal ? 'w-full' : ''}`}>
								{typeof (search.leftComponent) == "function" ? search.leftComponent() :
									search.leftComponent
								}

								{/* Render the input component to search through the data. */}
								<div className={`msa-input-outer ${isTrainingGuideModal ? 'w-full rounded-none' : ''} ${focusOn === "searchInput" && "focusOn"}`}>
									{search?.isSearchIconRequire &&
										<span className={`msa-search-icon ${isTrainingGuideModal ? 'search-icon-black' : ''}`}>
											<IconsPath.SearchIcon />
										</span>}

									<input
										ref={inputSearchRef}
										id="listComponentInputSearch"
										placeholder={search.placeholder}
										autoComplete='off'
										type='text' value={currentSearch}
										onFocus={() => { setFocusOn("searchInput") }}
										onBlur={() => { setFocusOn("") }}
										onChange={(e) => { handleChange("listComponentSearch", e.target.value, e) }}
										onKeyDown={(e) => { (!e.shiftKey) && handleChange("listComponentSearch", e.target.value, e) }}
										className={search?.searchInputClassName}
									/>
									{/* The clear option for the input field. */}
									{currentSearch && <button className='msaio-clear'
										onClick={(e) => {
											handleChange("listComponentSearch", "", { ...e, key: "Enter" })
										}}
									><IconsPath.ModalCloseIcon /></button>}
									{search?.provideOptionToSetSearchAsValue && currentSearch &&
										<GenericInput
											gibInnerClassName='!h-[26px]'
											inputDropdownExtraClass='!text-[11px]'
											genInputExtraClass='replenishment-assortment-input !ml-2 !mb-0 relative left-[5px] max-w-[120px] z-[50] shrink-0'
											type="dropdown"
											style = {{
												marginTop : "10px"
											}}
											placeholder = {"Send As Filter"}
											inputKey="searchItemCode"
											// value={null}
											iconRight={<Icons.DownArrowNew />}
											onChange={(val) => {
												if (search?.provideUpdateSelectedValueFromSearch) {
													let { currentSelectItem, selectedDataResponse } = search?.provideUpdateSelectedValueFromSearch?.({
														value: currentSearch,
														searchFilter: searchFilter,
														selectedData: selectedData,
														item: val
													})
													setCurrentSearch("");
													let updatedSelectedData = selectedDataResponse ? { ...currentSelectItem, ...selectedDataResponse } : { ...currentSelectItem, ...selectedData };
													setSelectedData(updatedSelectedData);
												}
											}}
											inputProps={() => ({
												modalMainClass: '',
												headerKeys: {
													"value": {}
												},
												itemKeys: {
													"value": [(states, functions, item) => {
														return (
															<p className='mb-0 text-fontBlack whitespace-nowrap'>{typeof (item?.value) == "function" ? item?.value() : item?.value}</p>
														)
													}]
												},
												getListData: () => items?.map(item => {
													return {
														key: item?.key,
														value: <LanguageTranslator>{item?.label || ''}</LanguageTranslator>
													}
												})
												// refreshData: refreshListData,
											})}
										/>
									}
								</div>
							</div>

							{props?.searchRightExtra ? props.searchRightExtra?.({
								listData: listData,
								selectedData: selectedData,
								apiAllData: apiAllData
							}) : null}

							{/* {
								search?.provideOptionToSetSearchAsValue && currentSearch &&
								<div className='flex items-center justify-end mt-[8px]'>
									{
										<GenericCustomButton
											type='underline'
											label={'Send As Filter'}
											rightIcon = {<Icons.DownArrowNew/>}
											className={'text-xs underline hover:text-primary'}
										/>
									}
									{
										items?.map(item => (
											<a
												onClick={(e) => {
													e.preventDefault();
													e.stopPropagation(); // 👈 stops event bubbling
													if (search?.provideUpdateSelectedValueFromSearch) {
														let { currentSelectItem, selectedDataResponse } = search?.provideUpdateSelectedValueFromSearch?.({
															value: currentSearch,
															searchFilter: searchFilter,
															selectedData: selectedData,
															item : item
														})
														setCurrentSearch("");
														let updatedSelectedData = selectedDataResponse ? { ...currentSelectItem, ...selectedDataResponse } : { ...currentSelectItem, ...selectedData };
														setSelectedData(updatedSelectedData);
													}
												}}
											>
												<Space>
													<GenericCustomButton
														label={item.label}
														className="text-xs underline hover:text-primary"
													/>
												</Space>
											</a>
										))
									}
								</div>
							} */}

							{/* Render the custom search options component */}
							{search?.searchOptions && (typeof search?.searchOptions === 'function' ? search?.searchOptions() : (
								<div className='msa-right'>
									<label>{`${props?.search?.searchOptionLabel || "Select Search Type"}`}</label>
									<select value={searchFilter} name="cars" id="cars" onChange={(e) => { handleChange("listComponentSearchType", "", e) }}>
										{Object.keys(search?.searchOptions || {})?.map((key, index) => {
											return <option key={`listDataSearchOption${index}`} value={key}>{search?.searchOptions?.[key]}</option>
										})}
									</select>
								</div>
							))}

							{/* Render the right comoponent of the input field */}
							{typeof (search.rightComponent) == "function" ? search.rightComponent() :
								search.rightComponent
							}
						</div>
					</React.Fragment>
			)
		)
	}

	// const renderTotalGuidesCount = () => {
	// 	return (
	// 		<div className='text-[#575D6A] text-xs border-y border-[#E3E4E7] px-4 py-3 mt-3 mb-2'>
	// 			Total Guides available : <span className='text-[#575D6A] font-bold'>{listData?.length ?? ''}</span>
	// 		</div>
	// 	)
	// }

	const renderTotalRecords = () => {
		let states = getComponentStates();
		// Render the total Records of the data if the total records keys is provided.
		return props.totalRecords && (
			// In second case the total records is going to be a key.
			<div className='list-modal-total-records'>
				<h3><LanguageTranslator>Total Records :</LanguageTranslator>&nbsp;</h3><span>{typeof (totalRecords) == "function" ? totalRecords(states) : totalRecords(states)}</span>
			</div>
		)
	}

	const renderMultiSelectOptions = () => {
		// Render the See Selected Data and Deselect all functionality in case we have multiselect functionality.
		return (
			props.multiselectOptions && (
				<div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>

					<div style={{ display: "flex", flexDirection: "row" }} >
						<input type='checkbox' />
						<LanguageTranslator tag='h4'>Show Selected Items</LanguageTranslator>
					</div>

					<button>
						<h4>Deselect All</h4>
					</button>

				</div>
			)
		)
	}

	const renderListData = () => {
		if (props.api) {
			if (currentPage == 1 && apiReduxData?.[`${props?.api?.apiName}Data`]?.isLoading) {
				return false;
			}
		}
		return true;
	}

	const [filteredData, setFilteredData] = useState(Object.values(selectedData || {}) || []);
	const [showSelected, setShowSelected] = useState(false)

	useEffect(() => {
		if (showSelected == false) {
			setFilteredData(Object.values(selectedData || {}))
		}
		if (Object.values(selectedData || {})?.length == 0 && showSelected) {
			setShowSelected(false)
		}
	}, [selectedData]);

	useEffect(() => {
		setFilteredData(Object.values(selectedData || {}))
	}, [showSelected]);

	const mapSelectedData = (showSelected || !showSelectedDataCheck) ? filteredData : filteredData?.slice(0, 1);
	const renderListTableData = (config) => {
		const { hideListData = false, hideSelectedData = false, hideSelectAll = false, hideLoader = false } = config || {};

		// Render the table of the list data.
		let id = props.multiselect ? props.multiselect?.selectId : "id";
		let selectedItemsLength = Object.keys(selectedData || {})?.length;
		const allStates = getComponentStates();
		const allFunctions = getComponentFunctions();
		return (
			<div className={`lcs-inner ${isTrainingGuideModal ? '!overflow-y-auto' : ''}`}>
				{props?.multiselect && Object.values(selectedData || {})?.length > 0 && showSelectedDataCheck && <GenericCustomButton className="show-selected-all text-[12px] font-medium px-[15px] text-fontBlack" label={`Show ${showSelected ? 'All' : 'Selected'}`} onClick={() => setShowSelected(!showSelected)} />}
				<div className={viewDataType === "table-view" ? `list-component-table-view ${(props?.api ? (!apiReduxData?.[`${api?.apiName}Data`]?.isLoading && listData?.length == 0 && selectedItemsLength == 0) : listData?.length == 0) && "lcgv-data"}` : "list-component-normal-view"}>
					{/* We will render the thead of the table when headerKeys length is > 1 */}
					{Object.keys(headerKeys || {})?.length > 1 &&
						<div id="list_component_main_li" className='lcv-table-head'>
							<ul className={`lcvth-row ${listData?.length == 0 ? 'header-full-no-data' : ''}`}>
								{Object.keys(headerKeys || {})?.map((headerKey, headerIndex) => {
									if (headerKey === "multiSelectCol" && !hideSelectAll) {
										return (
											<>
												{props.multiselect && (listData?.length > 0 || selectedItemsLength > 0) && <li onClick={() => showSelected ? null : handleChange("selectAll")} key={`mdlr-li listComponentSelectAll ${headerIndex}`}>
													<div className='mdlr-select-all'>
														{isAllListDataSelected() ? <IconsPath.SelectedItemIcon className='checkedIcon' /> : <IconsPath.DeselectedItemIcon />}
														{/* <label>Select All</label> */}
													</div>
												</li>}
											</>
										)
									}
									else {
										return (
											<li key={`${headerKey}_${headerIndex}`}>{typeof (headerKeys?.[headerKey]?.value) == "function" ? headerKeys?.[headerKey]?.value() : <LanguageTranslator tag="label">{headerKeys?.[headerKey]?.value || ""}</LanguageTranslator>}</li>
										)
									}
								})}
							</ul>
						</div>
					}

					{/* Render the body of the table component. */}
					{renderListData() && <div className={`modal-data-list-render ${listData?.length == 0 && '!overflow-hidden'} ${isTrainingGuideModal ? (listData?.length === 0 ? '!h-fit' : '!h-[calc(100%-235px)]') : ''}`}>
						{!hideSelectedData && (props?.multiselect && mapSelectedData?.map((item, index) => {
							// Render the list component row data
							return props?.renderCustomListCompleteItem ? props?.renderCustomListCompleteItem(allStates, allFunctions, item, index) : <li id="list_component_main_li" onClick={(e) => handleChange("selectItem", item)} onMouseLeave={(e) => handleMouseMove(e, null)} onMouseEnter={(e) => handleMouseMove(e, Number(index))} data-index={index} className={`mdlr-li ${hoverClassName} ${focusedIndex === index ? "hover" : ""}`} key={index}>
								{props?.renderCustomListItem ? props?.renderCustomListItem(allStates, allFunctions, item) : renderTableRowData(item)}
							</li>
						}))}

						{!showSelected && filteredData?.length > 1 && props.multiselect && showSelectedDataCheck && <li id="list_component_main_li" className='mdlr-li iugm-remove-file-btn' onClick={() => setShowSelected(!showSelected)}><td colSpan="100" className='px-[15px] text-[12px] font-medium'>+{filteredData?.length - 1} View More</td></li>}

						{
							!hideListData && <>

								{listData?.length === 0
									? (typeof props?.customNoDataFound === 'function'
										? props.customNoDataFound()
										: <NoDataFound />)
									: null}

								{listData?.length > 0 && !showSelected && listData?.filter(item => !selectedData?.[item?.[id]])?.map((item, index) => {
									// Render the list component row data
									return props?.renderCustomListCompleteItem ? props?.renderCustomListCompleteItem(allStates, allFunctions, item, index) : <li id="list_component_main_li" onMouseLeave={(e) => handleMouseMove(e, null)} onMouseEnter={(e) => handleMouseMove(e, Number(index) + Number(selectedItemsLength))} data-index={Number(index) + Number(selectedItemsLength)} className={`mdlr-li ${isListItemDisabled?.({ item, selectedData }) && "mdlr-li-disabled"}  ${hoverClassName} ${focusedIndex === (Number(index) + Number(selectedItemsLength)) ? "hover" : ""}`} onClick={() => !isListItemDisabled?.({ item, selectedData }) && handleChange("selectItem", item)} key={`listDataRow${index}`}>
										{props?.renderCustomListItem ? props?.renderCustomListItem(allStates, allFunctions, item) : renderTableRowData(item)}
									</li>
								})}

								{listData?.length > 0 && !showSelected && <td colSpan="100" className='!border-0' style={{ width: "100%", height: "1px", backgroundColor: "red", visibility: "hidden", opacity: 0 }} ref={lastListElementRef}></td>}
							</>
						}
					</div>}

					{!hideLoader &&
						props?.api && apiReduxData?.[`${api?.apiName}Data`]?.isLoading && (
							(currentPage <= 1) ? <ListComponentSkeltonLoader numberOfCols={Object.keys(headerKeys)?.length || 1} numberOfRows={Object.keys(itemKeys)?.some(key => itemKeys?.[key]?.length > 1) ? 2 : 1} /> :
								<tr>
									<td colSpan='100' className='spinnerClassName'>
										<GenericSpinnerLoader />
									</td>
								</tr>
						)}
				</div>
			</div>
		)
	}

	const renderTableRowData = (data) => {
		let id = props.multiselect ? props.multiselect?.selectId : "id";
		const allStates = getComponentStates();
		const allFunctions = getComponentFunctions();

		// Function to render all the row level data of the table.
		return (
			<>
				{/* Render the left icon to render the data */}
				{/* In case of multiselect data this is going to be a select icon */}

				{/* {props.multiselect && ((selectedData?.[data?.[id]]) ? <IconsPath.SelectedItemIcon /> : <IconsPath.DeselectedItemIcon />)} */}

				{/* else render the leftComponent */}
				{rowLeftComponent && (typeof (rowLeftComponent) == "function" ? rowLeftComponent(allStates, allFunctions, data) : rowLeftComponent)}
				{Object.keys(headerKeys || {})?.map((headerKey, headerIndex) => {
					if (headerKey === "multiSelectCol") {
						return (
							<>
								{props.multiselect && ((selectedData?.[data?.[id]]) ? <div className='mdlr-col'>
									<IconsPath.SelectedItemIcon className='checkedIcon' />
								</div> :
									<div className='mdlr-col'>
										<IconsPath.DeselectedItemIcon />
									</div>)}
							</>
						)
					}
					else {
						// Render each td according to each header Key item;
						return <div className={`mdlr-col list-col-${Object.keys(headerKeys || {}).length}`} key={headerIndex}>
							{/* Render each itemKey data inside the td */}
							{
								// We need to give the fontsize according to itemIndex 0, 1, 2;
								itemKeys?.[headerKey]?.map((item, itemIndex) => {

									return typeof (item) == "function"
										? item(allStates, allFunctions, data)
										: (isTrainingGuideModal
											? (<div className='flex items-center justify-between gap-2'>
												<div className='flex items-center gap-2'>
													<div>
														{
															data?.['fileType'] === 'Video' ? <FileVideo color='#2B83FF' /> : (data?.['fileType'] === 'Document' ? <FileText color='#EE5A24' /> : <FileImage color='#B98711' />)
														}
													</div>
													<div>
														<p className='mb-0 text-[#0F172A] text-[13px] font-semibold max-w-[16.875rem] whitespace-nowrap overflow-hidden overflow-ellipsis'>
															{data?.[item]}
														</p>
														<div className='text-[10px] text-[#8496A9]'>{data?.['fileType']}</div>
													</div>
												</div>
												<button className='flex items-center gap-2 text-[#8496A9] text-xs hover:opacity-75 whitespace-nowrap'>
													Open Link <SquareArrowOutUpRight size={'13'} />
												</button>
											</div>)
											: <LanguageTranslator tag="span" className='mdlr-multiple-row'>
												{showColor ?
													<ColorComponent color={data?.[item]} className='mr-[8px]' />
													: null}
												{data?.[item]}
											</LanguageTranslator>)
								})
							}
						</div>

					}
				})}
				{/* else render the rightComponent */}
				{rowRightComponent && (typeof (rowRightComponent) == "function" ? rowRightComponent(allStates, allFunctions, data) : rowRightComponent)}
			</>
		)
	}

	// ✅ Debounced version
	const handleDebouncedSearch = (value) => {
		if (debounceTimerRef.current) {
			clearTimeout(debounceTimerRef.current);
		}
		debounceTimerRef.current = setTimeout(() => {
			runSearch(value);
		}, 500); // Adjust delay as needed
	};

	// ✅ Your actual API call or search handler
	const runSearch = (value) => {
		if (currentPage == 1) {
			getTableData({
				search: value || "",
			});
		} else {
			setCurrentPage(1);
		}
	};

	// Functin: To handle all the changes inside this component
	const handleChange = (type, data, e) => {
		let id = props?.multiselect?.selectId || "id";
		switch (type) {
			case "selectItem": {
				if (props.multiselect) {
					let updatedSelectedData = { ...selectedData };
					if (updatedSelectedData?.[data?.[id]]) {
						delete updatedSelectedData?.[data?.[id]];
					} else {
						updatedSelectedData[data?.[id]] = data;
					}
					setSelectedData(updatedSelectedData);
					if (showSelected) {
						let filteredDataClone = Object.values(updatedSelectedData || {}).filter((item) =>
							Object.values(item)
								.join(" ") // Combine all values into a string
								.toLowerCase() // Convert to lowercase for case-insensitive search
								.includes(currentSearch.toLowerCase()) // Match the search query
						);
						setFilteredData(filteredDataClone);
					}
				} else if (props.submitHandler) {
					props.submitHandler(data);
					props?.closeModal?.();
				}
				break;
			}
			case "selectAll": {
				let isSelectAll = isAllListDataSelected();
				if (isSelectAll) {
					setSelectedData({});
				} else {
					let payload = { ...selectedData };
					listData?.map(item => {
						payload[item[id]] = item;
					})
					setSelectedData(payload);
				}
				break;
			}
			case "listComponentSearch": {
				let states = getComponentStates();
				let functions = getComponentFunctions();
				setCurrentSearch(prev => data);
				if (e?.key == "Enter" && showSelected) {
					let filteredDataClone = Object.values(selectedData || {}).filter((item) =>
						Object.values(item)
							.join(" ") // Combine all values into a string
							.toLowerCase() // Convert to lowercase for case-insensitive search
							.includes(currentSearch.toLowerCase()) // Match the search query
					);
					setFilteredData(filteredDataClone);
				}
				if (props.api) {
					if (props?.isDebounceAllowed) {
						handleDebouncedSearch(data)
					}
					if (e.key == "Enter" && !showSelected) {
						if (currentPage == 1) {
							getTableData({
								search: data || "",
							});
						} else {
							setCurrentPage(1);
						}
					}
					break;
				} else {
					const updatedData = props?.getListData?.() || [];
					if (props.search?.customSearchFunction)
						setListData(props.search?.customSearchFunction({ ...states, currentSearch: data, listData: updatedData }, functions));
				}
				break;
			}
			case "listComponentSearchType": {
				setSearchFilter(e.target.value);
				break;
			}
			case "finalSubmit": {
				props?.multiselect?.submitHandler?.(selectedData);
				props?.closeModal?.();
			}
			default:
				break;
		}
	}

	const renderSubmitButtons = () => {
		return (
			<div className='generic-form-footer'>
				<div></div>
				<div className='gff-right'>
					{(props.closeModal || props?.label?.closeModal) && <GenericCustomButton
						type="default"
						disabled={false}
						label="Close"
						onClick={() => props.closeModal()}
						size={footerButtonSize}
						className='whitespace-nowrap'
					/>}
					<GenericCustomButton
						type="primary"
						disabled={false}
						label={props.finalSubmitLabel || "Done"}
						onClick={() => handleChange("finalSubmit")}
						size={footerButtonSize}
						className='whitespace-nowrap'
					/>
				</div>
			</div>
		)
	}

	return (
		<div className={`list-component-section ${modalMainClass} ${search?.provideOptionToSetSearchAsValue && currentSearch ? 'dropdown-w-set-filter-button' : ''}`} id="listComponent">
			{renderHeaderComponent()}

			{/* Render the custom items at 0 index */}
			{props.renderCustomItems?.["0"] && props.renderCustomItems?.["0"]()}

			{renderSearchComponent()}

			{/* Render the custom items at 1st index */}
			{props.renderCustomItems?.["1"] && props.renderCustomItems?.["1"]({
				"listDataCount": listData?.length,
				"allData": getComponentStates()
			})}

			{renderTotalRecords()}

			{/* Render the custom items at 2nd index */}
			{props.renderCustomItems?.["2"] && props.renderCustomItems?.["2"]()}

			{props.multiselect && renderMultiSelectOptions()}

			{/* Render the custom items at 2nd index */}
			{props.renderCustomItems?.["3"] && props.renderCustomItems?.["3"]()}

			{props.type == 2 ? (
				<div className='modal-mapped-data'>
					{renderListTableData({ hideSelectedData: true, hideSelectAll: true })}
					{renderListTableData({ hideListData: true, hideSelectAll: true, hideLoader: true })}
				</div>
			) : renderListTableData({ hideSelectAll: props?.hideSelectAll || false })}

			{props.renderCustomItems?.["4"] && props.renderCustomItems?.["4"]()}

			{/* Render the final Submit Buttons */}

			{props.submitConfig?.renderLowerButtons ? props.submitConfig?.renderLowerButtons({
				listData: listData,
				selectedData: selectedData,
				handleChange: handleChange
			}) : props.multiselect && renderSubmitButtons()}

		</div>
	)
}

export default ListComponent